// store/scoreboard/scoreboardSlice.js
import { createSlice } from '@reduxjs/toolkit';

const scoreboardSlice = createSlice({
  name: 'scoreboard',
  initialState: {
    contestId: null,
    boards: {},
    counters: {
      students: null,
      schools: null,
    },
    initSchoolBoard: false,
    initClassesBoard: false,
    initStudentsBoard: false,
    userSchoolHouseId: undefined,
  },
  reducers: {
    setScoreboardData(state, action) {
      const { key, data = [] } = action.payload;
      state.boards[key] = data
    },
    setInitSchoolBoard(state, action) {
      state.initSchoolBoard = action.payload;
    },
    setInitClassesBoard(state, action) {
      state.initClassesBoard = action.payload;
    },
    setInitStudentsBoard(state, action) {
      state.initStudentsBoard = action.payload;
    },
    setUserSchoolHouseId(state, action) {
      state.userSchoolHouseId = action.payload;
    },
    setSchoolBoardData(state, action) {
      const { boards = {}, userSchoolHouseId = null, init = true } = action.payload;
      state.boards = { ...state.boards, ...boards };
      state.userSchoolHouseId = userSchoolHouseId;
      state.initSchoolBoard = init;
    },
    setClassesBoardData(state, action) {
      const { boards = {}, init = true } = action.payload;
      state.boards = { ...state.boards, ...boards };
      state.initClassesBoard = init;
    },
    setCounters(state, action) {
      state.counters = action.payload;
    },
    setCountersData(state, action) {
      const { counters = {}, contestId = null } = action.payload;
      state.counters = counters;
      state.contestId = contestId;
    },
    clearScoreboardData(state) {
      state.boards = {};
      state.counters = {
        students: null,
        schools: null,
      };
      state.contestId = null;
      state.initSchoolBoard = false;
    },
  },
});

export const scoreboardActions = scoreboardSlice.actions;
export default scoreboardSlice;
